/* Narrow PAT presentation/routing fixes; no booking or tracking settings. */
export const isPatCourse = (pcode) => String(pcode || "").toUpperCase() === "PAT";

export const initialPatLocation = (pcode, search) => {
  if (!isPatCourse(pcode)) return "";
  const location = (new URLSearchParams(search).get("location") || "").trim();
  const hasControlCharacter = Array.from(location).some((character) => {
    const code = character.charCodeAt(0);
    return code < 32 || code === 127;
  });
  return location.length >= 3 && location.length <= 200 && !hasControlCharacter
    ? location
    : "";
};

export const mergePatLocationSearch = (search, location, startDate) => {
  const params = new URLSearchParams(search);
  params.set("location", String(location || "").trim());
  const timestamp = new Date(startDate).getTime();
  if (Number.isFinite(timestamp)) params.set("start_date", String(timestamp));
  return "?" + params.toString();
};

export const initialPatStartDate = (pcode, search) => {
  const raw = isPatCourse(pcode) && new URLSearchParams(search).get("start_date");
  const timestamp = raw ? Number(raw) : NaN;
  const date = new Date(timestamp);
  return timestamp > 0 && Number.isFinite(date.getTime()) ? date : new Date();
};

export const patTrainingDescription = (pcode, description) => {
  if (!isPatCourse(pcode) || typeof description !== "string") return description;
  return description.replace(
    "that proves you are competent to carry out PAT testing.",
    "as evidence of completing Skills Training Group’s practical training and assessment.",
  );
};
